import { useMemo } from "react";

export function Particles() {
  const parts = useMemo(
    () =>
      Array.from({ length: 8 }, (_, i) => ({
        left: `${(i * 53 + 11) % 100}%`,
        size: 2 + (i % 3),
        dur: 18 + ((i * 3.1) % 12),
        delay: -((i * 2.3) % 18),
        silver: i % 3 === 0,
      })),
    []
  );
  return (
    <div aria-hidden="true" className="pointer-events-none fixed inset-0 z-[3] overflow-hidden" data-testid="mineral-particles">
      {parts.map((p, i) => (
        <span
          key={i}
          className={`mx-particle ${p.silver ? "mx-particle-silver" : ""}`}
          style={{ left: p.left, width: p.size, height: p.size, animationDuration: `${p.dur}s`, animationDelay: `${p.delay}s` }}
        />
      ))}
    </div>
  );
}
